/**
 * Hero slider init (Slick)
 * - autoplay ~2s
 */
(function ($) {
    function initHeroSliders() {
        var $sliders = $('.js-hero-slider');

        $sliders.each(function () {
            var $el = $(this);

            if ($el.hasClass('slick-initialized')) return;

            $el.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 2500,
                pauseOnHover: false,
                adaptiveHeight: true
            });
        });
    }

    $(document).ready(initHeroSliders);
})(window.jQuery);
